import React, { useCallback, useState, useEffect } from "react"; // Added useEffect import
import { useNavigate } from "react-router-dom";
import useTournamentDetails from "../../api/useTournamentDetails";
import useRegisterTournament from "../../api/useRegisterTournament";
import { getNXTournamentInfo } from "../../pages/TournamentDetails/helper";
import { NAVIGATION_ROUTES } from "../../constant";
import { toast } from "react-toastify"; // Added toast import
import { useTranslation } from "react-i18next"; // Added translation import
import styles from "./tournamentNavigationHelper.module.css";
import clsx from "clsx";
import Lottie from "react-lottie";
import animationData from "../../assets/lottie/loader.json";
import { createPortal } from "react-dom";
interface UseTournamentNavigationProps {
  gameName: string;
  ltid: number | undefined;
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export const useTournamentNavigation = ({ gameName, ltid }: UseTournamentNavigationProps) => {
  const navigate = useNavigate();
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(false);
  const { t } = useTranslation(); // Added translation hook
  const [pollingAttempted, setPollingAttempted] = useState<boolean>(false);

  const tournamentDetailsApi = useTournamentDetails({
    gameName,
    ltid: ltid as number,
  });

  const {
    registerTournament,
    loading: registerLoading,
    isPolling,
    hasGameplayServer,
  } = useRegisterTournament({
    gameName,
    ltid: ltid as number,
  });

  // Check for polling completion and server details
  // useEffect(() => {
  //   if (pollingAttempted && !isPolling && !hasGameplayServer && !registerLoading) {
  //     toast.error(t("serverDetailsNotFound") || "Server details not found. Please try again.");
  //     setPollingAttempted(false); // Reset for next attempt
  //   }
  // }, [isPolling, hasGameplayServer, registerLoading, pollingAttempted, t]);

  // Navigate to gameplay screen when server details are found
  // useEffect(() => {
  //   if (hasGameplayServer && pollingAttempted) {
  //     console.log("Server details found, navigating to gameplay");
  //     // Remove loader before navigation
  //     const loaderElement = document.getElementById('tournament-navigation-loader');
  //     if (loaderElement) {
  //       loaderElement.remove();
  //     }
  //     // Use requestAnimationFrame to ensure navigation happens in the next frame
  //     requestAnimationFrame(() => {
  //       navigate(NAVIGATION_ROUTES.GAMEPLAY, { replace: true });
  //     });
  //   }
  // }, [hasGameplayServer, pollingAttempted, navigate]);

  const goToTournamentDetails = useCallback(() => {
    if (ltid === undefined) return;
    navigate(
      `${NAVIGATION_ROUTES.TOURNAMENTDETAILS}/tournament?gameName=${gameName}&ltid=${ltid}`
    );
  }, [gameName, ltid, navigate]);

  const handleNavigation = useCallback(async () => {
    if (ltid === undefined || registerLoading || isPolling || isBtnDisabled) return;

    console.log("Starting navigation process");
    setIsBtnDisabled(true); // Disable button immediately to prevent multiple clicks

    try {

      await tournamentDetailsApi.fetchTournamentInfo(true);
      const tournamentInfo = getNXTournamentInfo();
      console.log("Tournament info from helper:", tournamentInfo);

      if (tournamentInfo?.skipTournamentDetailsPage) {
        console.log("Skipping tournament details page, registering for tournament");
        setPollingAttempted(true); // Set polling attempted flag when user clicks
        registerTournament(true);
      } else {
        console.log("Going to tournament details page");
        goToTournamentDetails();
      }
    } catch (error) {
      console.error("Error during navigation:", error);
      setIsBtnDisabled(false); // Re-enable button on error
      toast.error(t("somethingWentWrong") || "Something went wrong. Please try again.");
    }
  }, [
    ltid,
    registerLoading,
    isPolling,
    isBtnDisabled,
    tournamentDetailsApi,
    registerTournament,
    goToTournamentDetails,
    t,
  ]);

  const LoaderOverlay = useCallback(() => {
    if (registerLoading || isPolling || hasGameplayServer) {
      return createPortal(
        <div className={clsx(styles.loaderContainer)}>
          <Lottie
            className={clsx(styles.loaderLottie)}
            options={defaultOptions}
            isPaused={false}
            isStopped={false}
            eventListeners={[
              {
                eventName: 'complete',
              },
            ]}
            style={{
              width: '150px',
              height: 'auto',
              backgroundColor: 'transparent',
            }}
          />
        </div>,
        document.body
      );
    }
    return null;
  }, [registerLoading, isPolling, hasGameplayServer]);

  return {
    isBtnDisabled,
    registerLoading,
    isPolling,
    hasGameplayServer,
    handleNavigation,
    LoaderOverlay,
  };
};